export const iconFontAwesomeHouseholdFaucetDrip = (
	<i className="fa-solid fa-faucet-drip"></i>
);
